import {GET_USER} from "./user";

export const GET_STATIONINFO = 'GET_STATIONINFO'; // 获取站点信息
export const MODIFY_STATIONINFO = 'MODIFY_STATIONINFO'; // 修改站点信息

export default {
    state: {
        stationInfo: JSON.parse(sessionStorage.getItem('g7stationInfo')) || {
            stationName: '', // 站点名称
            classifyAuth: '', // 站点是否开放修改金额/升数加注的权限
            stationOilUnit: '',// 站点默认以什么方式加注
        },
    },
    getters: {
        [GET_STATIONINFO] (state) {
            if (typeof state.stationInfo === 'string'){
                state.stationInfo = JSON.parse(state.stationInfo);
            }
            return state.stationInfo;
        }
    },
    mutations: {
        [MODIFY_STATIONINFO] (state, item) {
            sessionStorage.setItem('g7stationInfo', JSON.stringify(item))
            Object.assign(state.stationInfo, item);
        }
    },
    actions: {
        [MODIFY_STATIONINFO] ({commit}, item) {
            commit(MODIFY_STATIONINFO, item);
        }
    }
};
